import { useState } from "react";
import { motion } from "framer-motion";
import { useScrollAnimation } from "../hooks/useScrollAnimation";
import { profileData } from "../data/profileData";
import { BsGithub, BsLinkedin, BsEnvelope } from "react-icons/bs";

const Contact = () => {
	const { ref, inView } = useScrollAnimation();
	const [form, setForm] = useState({ name: "", email: "", message: "" });

	const handleChange = (event) => {
		const { name, value } = event.target;
		setForm((prev) => ({ ...prev, [name]: value }));
	};

	const handleSubmit = (event) => {
		event.preventDefault();
		const subject = encodeURIComponent("Portfolio inquiry");
		const body = encodeURIComponent(
			`Name: ${form.name}\nEmail: ${form.email}\n\n${form.message}`,
		);
		window.location.href = `mailto:${profileData.email}?subject=${subject}&body=${body}`;
	};

	const containerVariants = {
		hidden: { opacity: 0 },
		visible: {
			opacity: 1,
			transition: { staggerChildren: 0.15 },
		},
	};

	const itemVariants = {
		hidden: { opacity: 0, y: 30 },
		visible: {
			opacity: 1,
			y: 0,
			transition: { duration: 0.5 },
		},
	};

	return (
		<section id="contact" className="section-card contact-section" ref={ref}>
			<motion.div
				initial="hidden"
				animate={inView ? "visible" : "hidden"}
				variants={containerVariants}
			>
				<motion.div className="section-header" variants={itemVariants}>
					<span>Contact</span>
					<h2>Let's connect</h2>
				</motion.div>
				<motion.div className="contact-content" variants={containerVariants}>
					<motion.div className="contact-info" variants={containerVariants}>
						<motion.div className="contact-item" variants={itemVariants}>
							<strong>Email</strong>
							<a href={`mailto:${profileData.email}`}>{profileData.email}</a>
						</motion.div>
						<motion.div className="contact-item" variants={itemVariants}>
							<strong>Phone</strong>
							<a href={`tel:${profileData.phone.replace(/\s+/g, "")}`}>
								{profileData.phone}
							</a>
						</motion.div>
						<motion.div className="contact-item" variants={itemVariants}>
							<strong>Social</strong>
							<div className="social-links">
								<a
									href={profileData.linkedin}
									target="_blank"
									rel="noreferrer"
									title="LinkedIn"
								>
									<BsLinkedin />
								</a>
								<a
									href={profileData.github}
									target="_blank"
									rel="noreferrer"
									title="GitHub"
								>
									<BsGithub />
								</a>
								<a href={`mailto:${profileData.email}`} title="Email">
									<BsEnvelope />
								</a>
							</div>
						</motion.div>
						<motion.div className="contact-item" variants={itemVariants}>
							<strong>Current Location</strong>
							<p>{profileData.location}</p>
						</motion.div>
					</motion.div>
					<motion.form
						className="contact-form"
						onSubmit={handleSubmit}
						variants={itemVariants}
					>
						<input
							type="text"
							name="name"
							placeholder="Your name"
							value={form.name}
							onChange={handleChange}
							required
						/>
						<input
							type="email"
							name="email"
							placeholder="Your email"
							value={form.email}
							onChange={handleChange}
							required
						/>
						<textarea
							name="message"
							placeholder="Your message"
							value={form.message}
							onChange={handleChange}
							rows="5"
							required
						/>
						<button type="submit" className="btn btn-primary">
							Send message
						</button>
					</motion.form>
				</motion.div>
			</motion.div>
		</section>
	);
};

export default Contact;
